"use client";

import React from "react";
import Button from "@/components/CommonComponent/button";
import Image from "next/image";
import Link from "next/link";
import { StyledWrapper } from "@/components/Styled";
import { usePathname } from "next/navigation";

const Index = ({ props }: any) => {
  const pathname = usePathname();
  const segments = pathname!.replace(/\/$/, "").split("/");
  const lastSegment = segments.pop();
  return (
    <div className="w-full bg-lightblue py-10 text-white lg:py-16">
      <div className="xl:w-[95%] 2xl:w-[80%] px-4 mx-auto flex flex-col gap-10">
        <div className="md:w-[80%] flex flex-col gap-4 mx-auto">
          <h2 className="text-center font-bold text-homeblack leading-[45px]">
            {props?.title || ""}
          </h2>
          <p className="text-center text-[16px] lg:text-[18px] text-homegrey">
            {props?.description || " "}
          </p>
        </div>
        <div className="flex justify-center gap-5 flex-wrap">
          {props?.card?.map((elem: any, i: number) => (
            <div
              key={i}
              className="rounded-xl p-8 sm:w-[45%] lg:w-[31%] flex flex-col gap-2  bg-white hover:shadow-xl"
            >
              {elem?.icon && props?.is_icon === true && (
                <div className="p-4 size-[72px] flex justify-center items-center rounded-lg bg-lightblue">
                  <Image
                    src={elem?.icon || ""}
                    alt={elem?.icon_alt || "icon"}
                    height={48}
                    width={36}
                  />
                </div>
              )}
              {elem?.icon && props?.is_icon === false && (
                <div className="flex justify-center items-center rounded-lg">
                  <Image
                    src={elem?.icon || ""}
                    alt={elem?.icon_alt || "icon"}
                    height={350}
                    width={360}
                    className="w-full rounded-md"
                  />
                </div>
              )}  
              {/* Conditional Rendering for SEO Service */}
              {
                elem?.title_link ? (
                  <a
                    href={elem?.title_link}
                    // className="text-[18px] lg:text-[22px] font-medium text-homeblack leading-[31px]"
                    style={{ fontWeight: 'bold', color: 'blue' }} // Add !important to style if necessary
                  >
                    {React.createElement(
                      elem?.title_tags || 'p',  // Fallback to <p> if title_tags is not available
                      { className: "!text-[18px] cursor-pointer !2xl:text-[22px] font-semibold text-homeblack  important" },
                      elem?.title
                    )}
                  </a>
                ) : (
                  React.createElement(
                    elem?.title_tags || 'p', // Fallback to <p> if title_tags is not available
                    { className: "!text-[18px] !2xl:text-[22px] font-semibold text-homeblack " },
                    elem?.title
                  )
                )
              }
              
              <StyledWrapper>
                <div
                  className="text-[16px] text-homegrey "
                  dangerouslySetInnerHTML={{ __html: elem?.description }}
                />
              </StyledWrapper>
            </div>
          ))}
        </div>
        <div className="flex justify-center">
          <Link href="/get-a-free-quote">
            <Button content="Get a Quote Now!" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Index;
